//Animation reveal titres
const ratio = .1
const options = {
    root: null,
    rootMargin: '0px',
    threshold: ratio
}
const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.intersectionRatio > ratio) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
        }
    })
}
window.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver(handleIntersect, options)
    const targets = document.querySelectorAll('.reveal');
    targets.forEach(function (target) {
        observer.observe(target);
    })
})


document.addEventListener("DOMContentLoaded", function () {


    /**
     * Appel de la gestion de cookies RGPD
     */
    let cookies = document.querySelector(".cookies");
    cookies.addEventListener("click", function (e) {
        e.preventDefault();
        if (tarteaucitron) {
            tarteaucitron.userInterface.openPanel();
        }
    });

    /**=============================================>>>>>
     = Topbut =
     ===============================================>>>>>*/
    let btn = document.querySelector("#topbut");
    if (btn != null) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 300) {
                btn.classList.add("visible");
            } else {
                btn.classList.remove("visible");
            }
        });
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("html").scrollTop = 0;
            document.querySelector("body").scrollTop = 0;
        });
    }


    /**
     Chiffres défilement
     */
    window.addEventListener('scroll', chiffresScroll);
    let viewed = false;

    function isScrolledIntoView(elem) {
        if (elem === null) {
            return false;
        }

        var docViewTop = window.scrollY;
        var docViewBottom = docViewTop + window.innerHeight;

        var elemTop, elemBottom;
        if (elem.getBoundingClientRect() !== undefined) {
            var boundingBox = elem.getBoundingClientRect();
            elemTop = boundingBox.top + window.scrollY;
            elemBottom = elemTop + boundingBox.height;
        }

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    function chiffresScroll() {
        if (isScrolledIntoView(document.querySelector(".bloc-chiffres")) && !viewed) {
            viewed = true;
            document.querySelectorAll(".chiffre").forEach(function (element) {
                var originalValue = parseFloat(element.textContent.replace(/\s+/g, "").replace(",", "."));

                if (!isNaN(originalValue)) {
                    var start = 0;
                    var target = originalValue;
                    var duration = 4000; // Durée totale de l'animation en millisecondes
                    var stepDuration = 16; // Environ 60 FPS
                    var steps = duration / stepDuration; // Nombre total d'étapes

                    var step = (target - start) / steps;

                    var currentStep = 0;
                    var interval = setInterval(function () {
                        currentStep++;
                        start += step;

                        if (currentStep >= steps || start >= target) {
                            clearInterval(interval);
                            start = target; // Assurez-vous que la valeur finale soit exacte
                        }

                        element.textContent = formatNumber(start, originalValue);
                    }, stepDuration);
                }
            });
        }
    }

// Fonction pour formater le nombre avec une seule décimale si nécessaire
    function formatNumber(number, originalValue) {
        if (originalValue % 1 !== 0) {
            return number.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        } else {
            return number.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
    }









    /**
     * Slider témoignages
     */
    const sliderTemoignages = document.querySelector('#temoignages');
    if (sliderTemoignages) {
        const flktysliderTemoignages = new Flickity(sliderTemoignages, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "center",
            "prevNextButtons": true,
            // "autoPlay": true,
            "autoPlay": 4000,
            "pauseAutoPlayOnHover": true
        });
    }


    /**
     Cases Autres dans page Je candidate
     */
    const situationElements = document.querySelectorAll('.situation .wpcf7-list-item');
    const autreSituation = document.querySelector('.autre-situation');
    if (situationElements) {
        // Ajoute un gestionnaire de clic à chaque élément de classe "situation"
        situationElements.forEach(function (element, index) {
            element.addEventListener('click', function () {
                // Vérifie si l'élément cliqué est le dernier
                if (index === situationElements.length - 1) {
                    // Affiche l'élément de classe "autre-situation"
                    autreSituation.style.display = 'block';
                } else {
                    // Masque l'élément de classe "autre-situation" et efface son contenu
                    autreSituation.style.display = 'none';
                    autreSituation.value = ''; // Efface le contenu
                }
            });
        });
    }


    const dernierElement = document.querySelector('.competence .wpcf7-list-item.last input');
    const autreCompetence = document.querySelector('.autre-competence');
    if (dernierElement) {
        // Ajoute un gestionnaire d'événements au changement de l'état de la case à cocher
        dernierElement.addEventListener('change', function () {
            if (dernierElement.checked) {
                // Si la case à cocher est cochée, affichez ".autre-competence"
                autreCompetence.style.display = 'block';
            } else {
                // Si la case à cocher est décochée, masquez ".autre-competence" et effacez son contenu
                autreCompetence.style.display = 'none';
                autreCompetence.value = ''; // Efface le contenu
            }
        });
    }


});


